import React, { useEffect, useRef, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { cn } from '../../../../shadcn/utils'
import { Icon } from '../../../atoms'

type ProposalAdvisorConversationMessageActionsDropdownProps = Readonly<{
  onDelete?: () => void
  menuOrientation: 'left' | 'right'
  className?: string
  show: boolean
}>

export function ProposalAdvisorConversationMessageActionsDropdown({
  onDelete,
  menuOrientation,
  className,
  show,
}: ProposalAdvisorConversationMessageActionsDropdownProps) {
  const [isOpen, setIsOpen] = useState(false)
  const detailsRef = useRef<null | HTMLDetailsElement>(null)

  useEffect(() => {
    const onBodyClick = (event: MouseEvent) => {
      if (
        !detailsRef.current ||
        detailsRef.current.contains(event.target as Node)
      ) {
        return
      }
      setIsOpen(false)
    }
    document.body.addEventListener('click', onBodyClick)
    return () => document.body.removeEventListener('click', onBodyClick)
  }, [])

  return (
    <details
      open={isOpen}
      ref={detailsRef}
      className={cn('relative', { invisible: !isOpen && !show }, className)}
    >
      <summary
        onClick={(ev) => {
          ev.preventDefault()
          setIsOpen((opened) => !opened)
        }}
        className='cursor-pointer list-none text-grey-700 hover:text-grey-800'
      >
        <span className='sr-only'>
          <FormattedMessage
            id='ui.ProposalAdvisorConversationMessageActionsDropdown.messageActions'
            defaultMessage='Détails du message'
          />
        </span>
        <Icon name='dots' size={16} />
      </summary>
      <ul
        className={cn(
          'absolute bottom-4',
          menuOrientation === 'left' ? 'right-4' : 'left-4',
        )}
      >
        {onDelete && (
          <li>
            <button
              onClick={() => onDelete()}
              className='rounded-[4px] border border-border bg-white px-4 py-3 text-red-500 hover:bg-grey-400'
            >
              <FormattedMessage
                id='ui.ProposalAdvisorConversationMessageActionsDropdown.deleteButton'
                defaultMessage='Supprimer'
              />
            </button>
          </li>
        )}
      </ul>
    </details>
  )
}
